module.exports = __webpack_public_path__ + "static/cpt-bw-43c6c7de33f49647b8382e03277027a5.webp";